import { useState } from "react";
import { Link } from "react-router-dom";
import { Check, AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import { startCheckout, StoryComingSoon, EXTENSION_TEXT } from "@/components/PurchaseCard";
import { apiError } from "@/lib/api";

export function PlanPanel({ plan }) {
  const [busy, setBusy] = useState(false);
  const buy = async () => {
    setBusy(true);
    try { await startCheckout(["extension"]); } catch (e) { toast.error(apiError(e)); setBusy(false); }
  };
  return (
    <section className="glass-card p-6 mb-8" data-testid="plan-panel" aria-labelledby="plan-h">
      <h2 id="plan-h" className="eyebrow mb-4">Your purchase</h2>
      <div className="grid sm:grid-cols-3 gap-4 mb-5">
        <div>
          <p className="text-3xl font-serif text-[#EDE6F7]" data-testid="plan-spaces">{plan.spaces_used} of {plan.recipient_limit}</p>
          <p className="text-sm text-[#A49CB8]">recipient spaces used · {plan.spaces_left} left</p>
        </div>
        <div>
          <p className="text-3xl font-serif text-[#EDE6F7]" data-testid="plan-recordings">{plan.recordings_done} of {plan.recordings_allowance}</p>
          <p className="text-sm text-[#A49CB8]">recordings · each 1–4 minutes</p>
        </div>
        <ul className="space-y-1 text-[#D2CBE0]" data-testid="plan-owned">
          <li className="flex gap-2"><Check className="h-5 w-5 text-[#B57BFF]" /> Original keepsake</li>
          {plan.extension && <li className="flex gap-2" data-testid="plan-extension-owned"><Check className="h-5 w-5 text-[#B57BFF]" /> Six more people</li>}
        </ul>
      </div>
      {plan.over_limit && (
        <p className="flex gap-2 mb-4 text-[#D9C6FF]" role="status" data-testid="plan-over-limit">
          <AlertTriangle className="h-5 w-5 shrink-0" /> This project was started before space limits applied and has more people than your plan includes. Nothing has been removed; you just can't add anyone else.
        </p>
      )}
      <div className="grid sm:grid-cols-2 gap-3">
        {!plan.extension && (
          <div className="rounded-xl border border-[rgba(139,44,255,0.35)] bg-[#1A1222] p-4" data-testid="plan-extension-offer">
            <p className="text-[#EDE6F7] font-semibold">Add six more people <span className="text-[#B57BFF]">+£4.99</span></p>
            <p className="text-sm text-[#B9B3C8] mt-1 mb-3">{EXTENSION_TEXT}</p>
            <button onClick={buy} disabled={busy} data-testid="buy-extension-btn" className="gold-btn h-12 px-5 rounded-full disabled:opacity-60">
              {busy ? "Opening secure checkout…" : "Add six more people · £4.99"}
            </button>
          </div>
        )}
        {plan.story_preview ? (
          <div className="rounded-xl border border-[rgba(139,111,176,0.45)] bg-[#1E1428] p-4" data-testid="story-preview-access">
            <p className="text-[#EDE6F7] font-semibold">Narrated story · preview access</p>
            <p className="text-sm text-[#B9B3C8] mt-1 mb-3">Family tree, AI-edited story review and voice permissions. Not yet on sale.</p>
            <Link to="/story-builder" data-testid="open-story-builder" className="ghost-gold inline-flex items-center h-11 px-5 rounded-full">Open the story builder</Link>
          </div>
        ) : <StoryComingSoon />}
      </div>
    </section>
  );
}
